// extracted by mini-css-extract-plugin
export default {"problemsSolvedTitle":"ProblemsSolvedTitle_problemsSolvedTitle__6BUWY"};